module.exports = __webpack_public_path__ + "assets/img/8.94a33ac7.png";